import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip,Button } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/organizationhistoriService"

import apiResponse from '../../../../../services/apiResponse'
// import DataTableBloc from '../Blocs/DataTableBloc'
import IndexBloc from '../../Index/Blocs/IndexBloc_'
import TmtEndModal from "./TmtEndModal"
import SKModal from "./SKModal"

const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    if (date) {
        return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};

class TableComponent extends Component {

    indexBloc = new IndexBloc()

    source
    defaultOrder = 'employee_transfer_detail_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            approveUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: 
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                },
            tmtEndUuid: null,
            tmtEndDate: null,
            tmtEndModal: false,
            skModalUuid: null,
            skDocumentUuid: null,
            skModal: false,
            employeeNip: '',
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            uuid: this.props?.uuid,
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchListDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    inactiveData = async () => {
        await this.indexBloc.fetchInactiveDetail({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.indexBloc.listDetailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.indexBloc.inactiveDetailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.indexBloc.listDetailChannel?.unsubscribe()
        this.indexBloc.inactiveDetailChannel?.unsubscribe()
    }

    columns = [
        {
            key: "employee_transfer_detail_employee_full_name",
            text: "Pegawai",
            sortable: true,
        },
        {
            key: "employee_transfer_detail_type",
            text: "Jenis Mutasi",
            sortable: false,
            cell: record => {
                if (record.employee_transfer_detail_type == 1) {
                    return "SK Pengangkatan Jabatan"
                } 
                if (record.employee_transfer_detail_type == 2) {
                    return "SK Pemberhentian & Pengangkatan Jabatan"
                }
                if (record.employee_transfer_detail_type == 3) {
                    return "SK Pemberhentian Jabatan"
                }
                return ""
            }
        },
        { 
            key: "employee_transfer_detail_work_unit_name",
            text: "Unit Kerja",
            sortable: true,
        },
        { 
            key: "employee_transfer_detail_position_name",
            text: "Jabatan",
            sortable: true,
        },
        { 
            key: "employee_transfer_detail_decree_number",
            text: "Nomor SK",
            sortable: true,
        }, 
        { 
            key: "employee_transfer_detail_decree_date",
            text: "Tanggal SK",
            sortable: true,
            cell: record => {
                return reformatDate(record.employee_transfer_detail_decree_date)
            }
        }, 
        { 
            key: "employee_transfer_detail_tmt_date_end",
            text: "TMT Berakhir",
            sortable: true,
            cell: record => {
                return (
                    <Fragment>
                        <label>TMT : {reformatDate(record.employee_transfer_detail_tmt_date_end)}</label> <br />
                        <Button 
                            size="sm" 
                            color="warning"
                            onClick={() => this.setState({ tmtEndUuid: record.employee_transfer_detail_uuid, tmtEndDate: record.employee_transfer_detail_tmt_date_end, tmtEndModal: true })}
                        >
                            <i className="uil-pen"></i>
                        </Button>
                    </Fragment>
                )
            }
        }, 
        {
            key: "employee_transfer_detail_document_uuid",
            text: "SK",
            sortable: false,
            width: '180',
            cell: record => {
                return (
                    <>
                        <label>Draft SK : </label>
                        <a href={record.document?.documents_path} target="_blank">{record.document ? <><i className="uil-download-alt"></i> Download</> : '#'}</a> <br />
                        <label>SK : </label> 
                        {
                            record?.document_decree != null ?  
                                <a target={"_blank"} href={record?.document_decree?.documents_path}>
                                    <i className="uil-download-alt"></i> Download
                                </a>
                            : '-'
                        }
                        <br />
                        <Button 
                            size="sm" 
                            color="warning"
                            onClick={() => this.setState({ skModalUuid: record.employee_transfer_detail_uuid, employeeNip: record.employee_nip, skModal: true })}
                        >
                            <i className="uil-pen"></i>
                        </Button>
                    </>
                )
            }
        }
    ]

    render() {
        return (
            <Fragment>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />

                <TmtEndModal 
                    uuid={this.state.tmtEndUuid} 
                    tmtEndDate={this.state.tmtEndDate} 
                    modal={this.state.tmtEndModal}  
                    toggle={() => this.setState({ tmtEndModal: !this.state.tmtEndModal })} 
                    handleReload={() => this.setTokenAPI()} 
                />

                <SKModal 
                    uuid={this.state.skModalUuid} 
                    employeeNip={this.state.employeeNip} 
                    modal={this.state.skModal}  
                    toggle={() => this.setState({ skModal: !this.state.skModal })} 
                    handleReload={() => this.setTokenAPI()} 
                />
            </Fragment>
        )
    }
}

export default TableComponent;